export enum AlternativesViewType
{
    Advanced = 1,
    Static = 2
}